import { createApp } from 'vue';
import './style.css';
import App from './App.vue';
import router from './router';
import { isDebugMode, setupDebug } from './utils/debug';

/**
 * 应用启动前先尝试启用 debug 模式（如 URL 命中 ?debug / ?debug=true）。
 *
 * 放在 createApp 之前执行，覆盖首屏直链场景，让 Vue 应用挂载前的
 * 启动期日志也能被 vConsole 捕获并写入下载 zip 包。
 *
 * setupDebug 内部幂等，重复调用不会重复挂载。
 */
if (isDebugMode()) setupDebug();

// 创建 Vue 应用
const app = createApp(App);
app.use(router);
app.mount('#app');
